import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './shared.module';
import { WaterLabRoutingModule } from '../routes/water-lab-routing.module';
import { WaterLabMainComponent,CreateLabRequestComponent, LabsMenuComponent, LabRequestsComponent, LabRequestHistoryComponent, PreviewLabelComponent, ShippingManifestComponent, LabResultsComponent, PrintLabelSummaryComponent, PendingManifestComponent, HostoricalManifestComponent, EnterDrawDateComponent, CancelComponent, PrintManifestComponent,AdditionalTestComponent, LabResultHistoryComponent, PrintLabResultComponent, ViewLabResultsComponent, RequestHistoryComponent, LabActionItemComponent, NoLabRequestComponent, RedrawLabsComponent, OverdueLabsComponent, MissingDrawDateComponent, UpcommingLabsComponent, UnmappedLabTestComponent, ViewLabAlertComponent} from '../components';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxBarcodeModule } from 'ngx-barcode';
import {SelectButtonModule} from 'primeng/selectbutton';
import { DelayDirective } from '../directive/delay.directive';
@NgModule({
  declarations: [
    WaterLabMainComponent,
    CreateLabRequestComponent,
    LabsMenuComponent,
    LabRequestsComponent,
    LabRequestHistoryComponent ,
    PreviewLabelComponent,
    PrintLabelSummaryComponent,
    ShippingManifestComponent,
    LabResultsComponent,
    PendingManifestComponent,
    HostoricalManifestComponent,
    EnterDrawDateComponent,CancelComponent,
    PrintManifestComponent,
    AdditionalTestComponent,
    DelayDirective,
    LabResultHistoryComponent,
    PrintLabResultComponent,
    ViewLabResultsComponent,
    RequestHistoryComponent,
    LabActionItemComponent,
    NoLabRequestComponent,
    RedrawLabsComponent,
    OverdueLabsComponent,
    MissingDrawDateComponent,
    UpcommingLabsComponent,
    UnmappedLabTestComponent,
    ViewLabAlertComponent
  ],
  imports: [
    CommonModule,
    WaterLabRoutingModule,
    SharedModule,
    NgSelectModule,
    NgxBarcodeModule,
    SelectButtonModule
  ],
  exports:[
    LabsMenuComponent,
    PreviewLabelComponent,
    PrintLabelSummaryComponent,CancelComponent,
    DelayDirective
  ],
  entryComponents: [CreateLabRequestComponent,LabRequestHistoryComponent,
    PreviewLabelComponent,PrintLabelSummaryComponent, EnterDrawDateComponent,CancelComponent,AdditionalTestComponent,LabResultHistoryComponent,ViewLabResultsComponent]
})
export class WaterLabModule { }
